import { Box, TextField, Button, Typography, useTheme } from "@mui/material";
import { BaseStepProps } from "../types/types";
import { tokens } from "../../../theme";

interface SupplierProps extends BaseStepProps {
  onPrevious: () => void;
  onSubmit: () => void;
  isSubmitting: boolean;
}

export default function Step4Supplier({
  formData,
  onChange,
  onPrevious,
  onSubmit,
  onSaveGear,
  isSubmitting,
}: SupplierProps) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
          gap: 2,
        }}
      >
        <Box>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color: colors.primary[400],
              mb: 0.5,
              fontSize: "0.88rem",
            }}
          >
            Supplier Name
          </Typography>
          <TextField
            fullWidth
            placeholder="e.g. Megatech"
            size="small"
            value={formData.supplierName}
            onChange={(e) => onChange("supplierName", e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: colors.primary[800],
                borderRadius: "16px",
                "& fieldset": { border: "none" },
                "&:hover fieldset": { border: "none" },
                "&.Mui-focused fieldset": { border: "none" },
              },
            }}
          />
        </Box>
        <Box>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color: colors.primary[400],
              mb: 0.5,
              fontSize: "0.88rem",
            }}
          >
            Contact Name
          </Typography>
          <TextField
            fullWidth
            placeholder="e.g. John Doe"
            size="small"
            value={formData.contactName}
            onChange={(e) => onChange("contactName", e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: colors.primary[800],
                borderRadius: "16px",
                "& fieldset": { border: "none" },
                "&:hover fieldset": { border: "none" },
                "&.Mui-focused fieldset": { border: "none" },
              },
            }}
          />
        </Box>
      </Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
          gap: 2,
        }}
      >
        <Box>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color: colors.primary[400],
              mb: 0.5,
              fontSize: "0.88rem",
            }}
          >
            Phone
          </Typography>
          <TextField
            fullWidth
            placeholder="+263"
            size="small"
            value={formData.supplierPhone}
            onChange={(e) => onChange("supplierPhone", e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: colors.primary[800],
                borderRadius: "16px",
                "& fieldset": { border: "none" },
                "&:hover fieldset": { border: "none" },
                "&.Mui-focused fieldset": { border: "none" },
              },
            }}
          />
        </Box>
        <Box>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color: colors.primary[400],
              mb: 0.5,
              fontSize: "0.88rem",
            }}
          >
            Email
          </Typography>
          <TextField
            fullWidth
            placeholder="john@example.com"
            size="small"
            value={formData.supplierEmail}
            onChange={(e) => onChange("supplierEmail", e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: colors.primary[800],
                borderRadius: "16px",
                "& fieldset": { border: "none" },
                "&:hover fieldset": { border: "none" },
                "&.Mui-focused fieldset": { border: "none" },
              },
            }}
          />
        </Box>
      </Box>
      <Box sx={{ width: { xs: "100%", sm: "48%" } }}>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            color: colors.primary[400],
            mb: 0.5,
            fontSize: "0.88rem",
          }}
        >
          Website
        </Typography>
        <TextField
          fullWidth
          placeholder="https://"
          size="small"
          value={formData.supplierWebsite}
          onChange={(e) => onChange("supplierWebsite", e.target.value)}
          sx={{
            "& .MuiOutlinedInput-root": {
              backgroundColor: colors.primary[800],
              borderRadius: "16px",
              "& fieldset": { border: "none" },
              "&:hover fieldset": { border: "none" },
              "&.Mui-focused fieldset": { border: "none" },
            },
          }}
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 2,
        }}
      >
        <Box sx={{ display: "flex", gap: 3 }}>
          <Typography
            onClick={onPrevious}
            sx={{
              cursor: "pointer",
              fontWeight: 600,
              textDecoration: "underline",
              color: colors.primary[400],
              fontSize: "0.9rem",
            }}
          >
            Previous
          </Typography>
          <Typography
            onClick={onSaveGear}
            sx={{
              cursor: "pointer",
              fontWeight: 600,
              textDecoration: "underline",
              color: colors.primary[400],
              fontSize: "0.9rem",
            }}
          >
            Save Gear
          </Typography>
        </Box>
        <Button
          variant="contained"
          size="large"
          onClick={onSubmit}
          disabled={isSubmitting}
          sx={{
            backgroundColor: colors.primary[400],
            px: 5,
            py: 1.2,
            borderRadius: "24px",
            "&:hover": { backgroundColor: colors.primary[500] },
            "&.Mui-disabled": { backgroundColor: colors.primary[800], color: colors.primary[900] },
          }}
        >
          {isSubmitting ? "Saving..." : "Save"}
        </Button>
      </Box>
    </Box>
  );
}
